module.exports = __webpack_public_path__ + "static/media/monstermovies.33421ca6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/projetos/monstermovies.png
// module id = 89
// module chunks = 0